<template>
  <v-container fluid class="ma-0 pa-0">
    <v-data-table
      :sort-by="['study_name']"
      multi-sort
      :headers="headers"
      :items="datasets"
      item-key="study_name"
      class="pb-1"
      disable-pagination
      hide-default-footer
    >
      <template v-slot:item.study_name="{ item }">
        <td class="subtitle-1 text-xs-left">{{ item.study_name }}</td>
      </template>

      <template v-slot:item.project_name="{ item }">
        <td class="subtitle-1 text-xs-left">{{ item.project.project_name }}</td>
      </template>

      <template v-slot:item.longitudinal="{ item }">
        <td class="text-subtitle-1 text-xs-center">
          <v-tooltip v-if="item.longitudinal" top color="primary">
            <template v-slot:activator="{ on: tooltip }">
              <span v-on="{ ...tooltip }">
                <v-chip
                  label
                  class="font-weight-bold px-2"
                  color="green lighten-4"
                  ><span class="ma-0 pa-0" style="width: 0.4em;"></span>L<span
                    class="ma-0 pa-0"
                    style="width: 0.4em;"
                  ></span
                  ><v-icon v-if="false" class="pl-2"
                    >mdi-chart-timeline-variant</v-icon
                  ></v-chip
                >
              </span>
            </template>
            <span>Longitudinal</span>
          </v-tooltip>

          <v-tooltip v-else top color="primary">
            <template v-slot:activator="{ on: tooltip }">
              <v-chip
                label
                class="font-weight-bold px-2"
                color="blue lighten-4"
                v-on="{ ...tooltip }"
                >CS<v-icon v-if="false" class="pl-2"
                  >mdi-drag-vertical-variant</v-icon
                ></v-chip
              >
            </template>
            <span>Cross-sectional</span>
          </v-tooltip>
        </td>
      </template>

      <template v-slot:item.is_public="{ item }">
        <td class="text-subtitle-1 text-xs-center">
          <v-tooltip v-if="item.project.is_public" top color="primary">
            <template v-slot:activator="{ on: tooltip }">
              <span v-on="{ ...tooltip }">
                <v-chip
                  label
                  class="font-weight-bold pa-2 mr-2"
                  color="green lighten-4"
                >
                  <v-icon center>mdi-lock-open-variant-outline</v-icon>
                </v-chip>
              </span>
            </template>
            <span class="subtitle-1"> Public </span>
          </v-tooltip>

          <v-tooltip v-else top color="primary">
            <template v-slot:activator="{ on: tooltip }">
              <span v-on="{ ...tooltip }">
                <v-chip
                  label
                  class="font-weight-bold pa-2 mr-2"
                  color="red lighten-4"
                >
                  <v-icon center>mdi-lock-outline</v-icon>
                </v-chip>
              </span>
            </template>
            <span class="subtitle-1"> Private </span>
          </v-tooltip>
        </td>
      </template>

      <template v-slot:item.num_subjects="{ item }">
        <td class="subtitle-1 text-xs-left">{{ item.num_subjects }}</td>
      </template>

      <template v-slot:item.name="{ item }">
        <td class="text-subtitle-1 text-xs-left">
          <v-tooltip top color="primary">
            <template v-slot:activator="{ on: tooltip }">
              <v-icon
                color="primary"
                class="mr-1"
                @click="routeToDatasetSummary(item.id)"
                v-on="{ ...tooltip }"
                >info</v-icon
              >
            </template>
            <span>Learn more about this dataset.</span>
          </v-tooltip>
        </td>
      </template>
      <template v-slot:no-data>
        No datasets available.
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { mapState } from 'vuex';
import { state } from '@/store/modules/datasetSummary/types';

export default {
  data() {
    return {
      headers: [
        {
          text: 'Dataset',
          value: 'study_name',
          class: 'text-subtitle-1 font-weight-bold',
          sortable: true,
        },
        {
          text: 'Project',
          value: 'project_name',
          class: 'text-subtitle-1 font-weight-bold',
          sortable: true,
        },
        {
          text: 'Type',
          value: 'longitudinal',
          class: 'text-subtitle-1 font-weight-bold',
          sortable: true,
        },
        {
          text: 'Access',
          value: 'is_public',
          class: 'text-subtitle-1 font-weight-bold',
          sortable: true,
        },
        {
          text: 'Info',
          value: 'name',
          align: 'left',
          sortable: false,
          class: 'text-subtitle-1 font-weight-bold',
        },
        {
          text: 'Subject Count',
          value: 'num_subjects',
          class: 'text-subtitle-1 font-weight-bold',
          sortable: true,
        },
      ],
    };
  },
  computed: {
    ...mapState('datasetSummary', {
      collection: state.COLLECTION,
    }),
  },
  watch: {},
  created() {
    this.datasets = this.collection.studies.map(x => x.study);
  },
  methods: {
    routeToDatasetSummary(id) {
      let route = this.$router.resolve(`datasets/${id}`);
      window.open(route.href, '_blank');
    },
  },
};
</script>

<style></style>
